import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import Sidebar from 'components/shared/sidebar/component';
import { SIDEBAR_MODE_FACILITATOR } from 'components/constants';
import NewTransaction from 'components/shared/transaction/new/component';
export default function ViewBulkTransaction() {
    var facilitatorActionType = useParams().facilitatorActionType;
    return (React.createElement(Fragment, null,
        React.createElement(Sidebar, { type: SIDEBAR_MODE_FACILITATOR }),
        React.createElement(NewTransaction, { isFacilitatorBulkView: facilitatorActionType === 'mass-transaction' })));
}
